import CustomUploadAdapterPlugin from "../CustomUploadAdapter";

const editorConfiguration = {
  toolbar: [
    "heading",
    "alignment",
    "|",
    "bold",
    "italic",
    "underline",
    "link",
    "bulletedList",
    "numberedList",
    "|",
    "fontFamily",
    "fontSize",
    "fontColor",
    "removeFormat",
    "outdent",
    "indent",
    "|",
    "horizontalLine",
    "imageUpload",
    "insertTable",
    "mediaEmbed",
    "htmlEmbed",
    "undo",
    "redo",
  ],
  fontSize: {
    options: ['8px', '9px', '10px', '11px', '12px','14px', '16px', '18px', '20px' ,'22px', '24px', '26px', '28px', '28px', '36px' ]
  },
  language: 'en',
  image: {
    toolbar: [
      'imageTextAlternative',
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
      'linkImage'
    ]
  },
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "tableCellProperties",
      "tableProperties",
    ],
    tableProperties: {
      defaultProperties: {
        width: "100%",
        alignment: "center",
      },
    },
  },
  link: {
    defaultProtocol: "https://",
  },
  extraPlugins: [CustomUploadAdapterPlugin],
  site: ""
};

export default editorConfiguration;
